export const companies = [
  { id: "01,01", label: "Adoro/01" },
  { id: "01,02", label: "Adoro/02" },
  { id: "01,03", label: "Adoro/03" },
  { id: "01,04", label: "Adoro/04" },
  { id: "01,05", label: "Adoro/05" },
  { id: "01,06", label: "Adoro/06" },
  { id: "01,07", label: "Adoro/07" },
  { id: "01,08", label: "Adoro/08" },
  { id: "01,09", label: "Adoro/09" },
  { id: "01,0A", label: "Adoro/0A" },
  { id: "01,0B", label: "Adoro/0B" },
  { id: "01,0T", label: "Adoro/0T" },
  { id: "03,01", label: "Clml/01" },
  { id: "06,01", label: "Gmsbs/01" },
  { id: "07,01", label: "Rnx2/01" },
  { id: "09,01", label: "Safegg/01" },
  { id: "10,01", label: "Simplify/01" },
  { id: "13,01", label: "Vista Foods/01" },
];

// Empresas/filiais impedidas de abrir novas solicitações de serviço
export const BLOCKED_NEW_RS_COMPANIES = ["01,02"];
